export default __webpack_public_path__ + "static/media/larry-page.293ffdab.jpeg";